import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

type SectionProps = {
	gap?: string
}

type TextProps = {
	variant: 'small' | 'large'
}

type ChipProps = {
	active?: boolean
}

const DefaultProps = (variant: 'small' | 'large') => {
	return `
		font-size: ${variant === 'large' ? '16px' : '14px'};
		font-weight: ${variant === 'large' ? 600 : 500};
		line-height: ${variant === 'large' ? '24px' : '22px'};
	`
}

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	margin: 0 auto;
	max-width: 648px;
	background: white;
	padding: 40px 20px;
`

export const Section = styled.section<SectionProps>`
	display: flex;
	flex-direction: column;
	gap: ${({ gap }) => gap};

	@media (max-width: 648px) {
		gap: 32px;
	}

	& > svg {
		align-self: center;
	}

	#accept-label {
		font-size: 13px;
		font-weight: 600;
		color: ${tokens.color_primary};
	}
`

export const Text = styled.p<TextProps>`
	color: ${tokens.color_gray_dark};
	font-style: normal;
	${({ variant }) => DefaultProps(variant)};
`

export const Link = styled.span<TextProps>`
	color: ${tokens.color_primary};
	text-decoration: underline;
	cursor: pointer;
	${({ variant }) => DefaultProps(variant)};
`

export const UnorderedList = styled.ul`
	list-style-position: inside;
	padding-left: 16px;
`

export const Chip = styled.span<ChipProps>`
	display: flex;
	height: 32px;
	padding: 10px 12px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	border-radius: 100px;
	width: fit-content;
	font-size: 14px;
	cursor: pointer;

	color: ${({ active }) =>
		active ? tokens.color_white : tokens.color_gray_dark};
	background-color: ${({ active }) =>
		active ? tokens.color_primary : tokens.color_gray_light};
`

export const ChipContainer = styled.div`
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	margin-top: 32px;
`

export const ListItem = styled.li`
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	color: ${tokens.color_gray_dark};
`

export const Small = styled.span<{ bold?: boolean; cursor?: string }>`
	color: ${({ bold }) =>
		bold ? tokens.color_primary : tokens.color_gray_dark};
	font-weight: ${({ bold }) => (bold ? 600 : 400)};
	font-size: 12px;
	font-style: normal;
	line-height: 18px;
	letter-spacing: -0.4px;
	cursor: ${({ cursor }) => cursor || 'default'};
`

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: 8px;
	font-size: 14px;
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};
	line-height: 20px;
	font-weight: 600;
	cursor: pointer;

	input {
		cursor: pointer;
	}
`
